// Values mirror Walleon.Domain/Enums — the API serializes enums as numbers.

export const TransactionType = { Income: 1, Expense: 2, Transfer: 3, Investment: 4 } as const
export type TransactionType = (typeof TransactionType)[keyof typeof TransactionType]
export const TRANSACTION_TYPE_LABEL: Record<TransactionType, string> = {
  1: 'Receita', 2: 'Despesa', 3: 'Transferência', 4: 'Investimento',
}

export const TransactionStatus = { Pending: 1, Confirmed: 2, Cancelled: 3 } as const
export type TransactionStatus = (typeof TransactionStatus)[keyof typeof TransactionStatus]
export const TRANSACTION_STATUS_LABEL: Record<TransactionStatus, string> = {
  1: 'Pendente', 2: 'Confirmado', 3: 'Cancelado',
}

export const TransactionHistoryAction = {
  Created: 1, Updated: 2, Confirmed: 3, Cancelled: 4, Deleted: 5, InvoicePaid: 6,
} as const
export type TransactionHistoryAction = (typeof TransactionHistoryAction)[keyof typeof TransactionHistoryAction]
export const TRANSACTION_HISTORY_ACTION_LABEL: Record<TransactionHistoryAction, string> = {
  1: 'Criado', 2: 'Alterado', 3: 'Confirmado', 4: 'Cancelado', 5: 'Excluído', 6: 'Fatura paga',
}

export const AccountType = { Checking: 1, Savings: 2, Investment: 3, CreditCard: 4, Cash: 5, Benefit: 6 } as const
export type AccountType = (typeof AccountType)[keyof typeof AccountType]
export const ACCOUNT_TYPE_LABEL: Record<AccountType, string> = {
  1: 'Corrente', 2: 'Poupança', 3: 'Investimento', 4: 'Cartão de crédito', 5: 'Carteira', 6: 'Benefício',
}

/** Como o cartão paga: crédito (fatura), débito (sai da conta na hora) ou pré-pago (saldo próprio, como vale-alimentação). */
export const ModalidadeCartao = { Credito: 1, Debito: 2, PrePago: 3 } as const
export type ModalidadeCartao = (typeof ModalidadeCartao)[keyof typeof ModalidadeCartao]
export const MODALIDADE_CARTAO_LABEL: Record<ModalidadeCartao, string> = { 1: 'Crédito', 2: 'Débito', 3: 'Pré-pago' }

export const GoalStatus = { Active: 1, Completed: 2, Cancelled: 3 } as const
export type GoalStatus = (typeof GoalStatus)[keyof typeof GoalStatus]
export const GOAL_STATUS_LABEL: Record<GoalStatus, string> = {
  1: 'Em andamento', 2: 'Concluída', 3: 'Cancelada',
}

export const ConnectionStatus = { Active: 1, Expired: 2, Error: 3, Pending: 4 } as const
export type ConnectionStatus = (typeof ConnectionStatus)[keyof typeof ConnectionStatus]
export const CONNECTION_STATUS_LABEL: Record<ConnectionStatus, string> = {
  1: 'Ativa', 2: 'Expirada', 3: 'Com erro', 4: 'Pendente',
}

export const PluggyAmbiente = { Sandbox: 1, Producao: 2 } as const
export type PluggyAmbiente = (typeof PluggyAmbiente)[keyof typeof PluggyAmbiente]

/** Nova = sem lançamento manual parecido. PossivelDuplicata = achou um com o mesmo valor, em data próxima. */
export const PluggyPendenciaTipo = { Nova: 0, PossivelDuplicata: 1, Transferencia: 2, Estorno: 3, PagamentoFatura: 4, PagamentoFaturaConta: 5 } as const
export type PluggyPendenciaTipo = (typeof PluggyPendenciaTipo)[keyof typeof PluggyPendenciaTipo]

/** Vínculo Pluggy: Pendente = sem corte definido (não sincroniza); Concluida = corte definido (ou vínculo antigo, sem corte). */
export const PluggyConfiguracaoStatus = { Pendente: 1, Concluida: 2 } as const
export type PluggyConfiguracaoStatus = (typeof PluggyConfiguracaoStatus)[keyof typeof PluggyConfiguracaoStatus]

export const TipoRecorrencia = {
  Diaria: 1, Semanal: 2, Quinzenal: 3, Mensal: 4, Bimestral: 5, Trimestral: 6, Anual: 7, Personalizada: 8,
} as const
export type TipoRecorrencia = (typeof TipoRecorrencia)[keyof typeof TipoRecorrencia]
export const TIPO_RECORRENCIA_LABEL: Record<TipoRecorrencia, string> = {
  1: 'Diária', 2: 'Semanal', 3: 'Quinzenal', 4: 'Mensal', 5: 'Bimestral', 6: 'Trimestral', 7: 'Anual', 8: 'Personalizada',
}

export const StatusFatura = { Aberta: 1, Fechada: 2, Paga: 3 } as const
export type StatusFatura = (typeof StatusFatura)[keyof typeof StatusFatura]
export const STATUS_FATURA_LABEL: Record<StatusFatura, string> = {
  1: 'Aberta', 2: 'Fechada', 3: 'Paga',
}

export const TipoAlerta = {
  OrcamentoAtingido: 1, VencimentoConta: 2, MetaAtrasada: 3, ResumoSemanal: 4, SaldoBaixo: 5, FaturaCartao: 6,
} as const
export type TipoAlerta = (typeof TipoAlerta)[keyof typeof TipoAlerta]

export const CicloCobranca = { Mensal: 1, Anual: 2 } as const
export type CicloCobranca = (typeof CicloCobranca)[keyof typeof CicloCobranca]
export const CICLO_LABEL: Record<CicloCobranca, string> = { 1: 'Mensal', 2: 'Anual' }

export const StatusAssinatura = { Trial: 1, Ativa: 2, Pendente: 3, Inadimplente: 4, Cancelada: 5 } as const
export type StatusAssinatura = (typeof StatusAssinatura)[keyof typeof StatusAssinatura]
export const STATUS_ASSINATURA_LABEL: Record<StatusAssinatura, string> = {
  1: 'Em teste', 2: 'Ativa', 3: 'Aguardando pagamento', 4: 'Inadimplente', 5: 'Cancelada',
}

export const StatusPagamento = { Pendente: 1, Pago: 2, Falhou: 3, Estornado: 4, Cancelado: 5 } as const
export type StatusPagamento = (typeof StatusPagamento)[keyof typeof StatusPagamento]
export const STATUS_PAGAMENTO_LABEL: Record<StatusPagamento, string> = {
  1: 'Pendente', 2: 'Pago', 3: 'Falhou', 4: 'Estornado', 5: 'Cancelado',
}

export const GatewayPagamento = { MercadoPago: 1, Stripe: 2, PagarMe: 3 } as const
export type GatewayPagamento = (typeof GatewayPagamento)[keyof typeof GatewayPagamento]
export const GATEWAY_LABEL: Record<GatewayPagamento, string> = {
  1: 'Mercado Pago', 2: 'Stripe', 3: 'Pagar.me',
}

export const AmbienteGateway = { Sandbox: 1, Producao: 2 } as const
export type AmbienteGateway = (typeof AmbienteGateway)[keyof typeof AmbienteGateway]
export const AMBIENTE_GATEWAY_LABEL: Record<AmbienteGateway, string> = { 1: 'Sandbox', 2: 'Produção' }

export const ProvedorEmail = { Smtp: 1, Resend: 2, SendGrid: 3 } as const
export type ProvedorEmail = (typeof ProvedorEmail)[keyof typeof ProvedorEmail]
export const PROVEDOR_EMAIL_LABEL: Record<ProvedorEmail, string> = { 1: 'SMTP', 2: 'Resend', 3: 'SendGrid' }

export const CampoRegraCategorizacao = { Descricao: 1, Valor: 2, Tipo: 3, Conta: 4, CategoriaPluggy: 5 } as const
export type CampoRegraCategorizacao = (typeof CampoRegraCategorizacao)[keyof typeof CampoRegraCategorizacao]
export const CAMPO_REGRA_LABEL: Record<CampoRegraCategorizacao, string> = {
  1: 'Descrição', 2: 'Valor', 3: 'Tipo', 4: 'Conta', 5: 'Categoria da Pluggy',
}

export const OperadorRegraCategorizacao = { Contem: 1, Igual: 2, ComecaCom: 3, Entre: 4, MaiorQue: 5, MenorQue: 6 } as const
export type OperadorRegraCategorizacao = (typeof OperadorRegraCategorizacao)[keyof typeof OperadorRegraCategorizacao]
export const OPERADOR_REGRA_LABEL: Record<OperadorRegraCategorizacao, string> = {
  1: 'contém', 2: 'é igual a', 3: 'começa com', 4: 'está entre', 5: 'é maior que', 6: 'é menor que',
}
/** Operadores válidos por campo — a UI só oferece o que faz sentido pra cada um. */
export const OPERADORES_POR_CAMPO: Record<CampoRegraCategorizacao, OperadorRegraCategorizacao[]> = {
  1: [1, 2, 3], // Descrição: contém / igual / começa com
  2: [2, 5, 6, 4], // Valor: igual / maior / menor / entre
  3: [2], // Tipo: só igual
  4: [1, 2], // Conta: contém / igual
  5: [2], // Categoria da Pluggy: só igual
}

export const OrigemNota = { Manual: 1, QrCode: 2, Ocr: 3, Sefaz: 4 } as const
export type OrigemNota = (typeof OrigemNota)[keyof typeof OrigemNota]
export const ORIGEM_NOTA_LABEL: Record<OrigemNota, string> = {
  1: 'Digitada', 2: 'QR Code', 3: 'Foto (OCR)', 4: 'SEFAZ',
}

export const StatusNota = { Completa: 1, Pendente: 2 } as const
export type StatusNota = (typeof StatusNota)[keyof typeof StatusNota]
/** Prazo da consulta pública da SEFAZ: passados 180 dias da emissão, só vêm os dados de identificação, sem itens. */
export const PRAZO_CONSULTA_NOTA_DIAS = 180

export const NivelPermissao = { Nenhum: 0, Ver: 1, Editar: 2 } as const
export type NivelPermissao = (typeof NivelPermissao)[keyof typeof NivelPermissao]
export const NIVEL_PERMISSAO_LABEL: Record<NivelPermissao, string> = {
  0: 'Sem acesso', 1: 'Pode ver', 2: 'Pode editar',
}

export const StatusCompartilhamento = { Pendente: 1, Aceito: 2, Recusado: 3, Revogado: 4 } as const
export type StatusCompartilhamento = (typeof StatusCompartilhamento)[keyof typeof StatusCompartilhamento]
export const STATUS_COMPARTILHAMENTO_LABEL: Record<StatusCompartilhamento, string> = {
  1: 'Pendente', 2: 'Aceito', 3: 'Recusado', 4: 'Revogado',
}

export const CanalAlerta = { Push: 1, Email: 2, Ambos: 3 } as const
export type CanalAlerta = (typeof CanalAlerta)[keyof typeof CanalAlerta]
export const CANAL_ALERTA_LABEL: Record<CanalAlerta, string> = {
  1: 'Push', 2: 'E-mail', 3: 'Ambos',
}

/** Ao editar/excluir uma parcela de compra no cartão: quais parcelas a ação atinge. */
export const EscopoParcelas = { Apenas: 1, Proximas: 2, Todas: 3 } as const
export type EscopoParcelas = (typeof EscopoParcelas)[keyof typeof EscopoParcelas]

export const SistemaAmortizacao = { Manual: 1, Price: 2, Sac: 3 } as const
export type SistemaAmortizacao = (typeof SistemaAmortizacao)[keyof typeof SistemaAmortizacao]
export const SISTEMA_AMORTIZACAO_LABEL: Record<SistemaAmortizacao, string> = {
  1: 'Manual (rateio simples)', 2: 'Price (parcelas fixas)', 3: 'SAC (parcelas decrescentes)',
}

export const StatusFinanciamento = { Ativo: 1, Encerrado: 2, QuitadoAntecipadamente: 3 } as const
export type StatusFinanciamento = (typeof StatusFinanciamento)[keyof typeof StatusFinanciamento]
export const STATUS_FINANCIAMENTO_LABEL: Record<StatusFinanciamento, string> = {
  1: 'Ativo', 2: 'Encerrado', 3: 'Quitado antecipadamente',
}

export const StatusParcelaFinanciamento = { Pendente: 1, Paga: 2, QuitadaAntecipadamente: 3 } as const
export type StatusParcelaFinanciamento = (typeof StatusParcelaFinanciamento)[keyof typeof StatusParcelaFinanciamento]
export const STATUS_PARCELA_FINANCIAMENTO_LABEL: Record<StatusParcelaFinanciamento, string> = {
  1: 'Pendente', 2: 'Paga', 3: 'Quitada antecipadamente',
}

/** Índice que corrige o saldo devedor mês a mês, além dos juros contratuais (financiamento imobiliário). */
export const IndiceCorrecaoMonetaria = { Nenhum: 0, TR: 1, IPCA: 2, IGPM: 3 } as const
export type IndiceCorrecaoMonetaria = (typeof IndiceCorrecaoMonetaria)[keyof typeof IndiceCorrecaoMonetaria]
export const INDICE_CORRECAO_LABEL: Record<IndiceCorrecaoMonetaria, string> = {
  0: 'Sem correção', 1: 'TR', 2: 'IPCA', 3: 'IGP-M',
}

export const EstrategiaAmortizacaoExtra = { ReduzirPrazo: 1, ReduzirParcela: 2 } as const
export type EstrategiaAmortizacaoExtra = (typeof EstrategiaAmortizacaoExtra)[keyof typeof EstrategiaAmortizacaoExtra]
export const ESTRATEGIA_AMORTIZACAO_LABEL: Record<EstrategiaAmortizacaoExtra, string> = {
  1: 'Reduzir prazo (mantém a parcela)', 2: 'Reduzir parcela (mantém o prazo)',
}

// ── Veículos ──────────────────────────────────────────────────────────────────
export const TipoVeiculo = { Carro: 1, Moto: 2 } as const
export type TipoVeiculo = (typeof TipoVeiculo)[keyof typeof TipoVeiculo]
export const TIPO_VEICULO_LABEL: Record<TipoVeiculo, string> = { 1: 'Carro', 2: 'Moto' }

export const TipoEnergia = { Combustao: 1, Eletrico: 2, Hibrido: 3, HibridoPlugin: 4 } as const
export type TipoEnergia = (typeof TipoEnergia)[keyof typeof TipoEnergia]
export const TIPO_ENERGIA_LABEL: Record<TipoEnergia, string> = {
  1: 'Combustão', 2: 'Elétrico', 3: 'Híbrido', 4: 'Híbrido plug-in',
}

/** Fipe = catálogo compartilhado; Manual = modelo privado do usuário. */
export const OrigemModelo = { Fipe: 1, Manual: 2 } as const
export type OrigemModelo = (typeof OrigemModelo)[keyof typeof OrigemModelo]

export const StatusVeiculo = { Ativo: 1, Vendido: 2 } as const
export type StatusVeiculo = (typeof StatusVeiculo)[keyof typeof StatusVeiculo]
export const STATUS_VEICULO_LABEL: Record<StatusVeiculo, string> = { 1: 'Ativo', 2: 'Vendido' }

/** Só pré-marca o formulário de abastecimento. */
export const MetodoConsumo = { TanqueCheio: 1, Reserva: 2, SemCalculo: 3 } as const
export type MetodoConsumo = (typeof MetodoConsumo)[keyof typeof MetodoConsumo]
export const METODO_CONSUMO_LABEL: Record<MetodoConsumo, string> = { 1: 'Tanque cheio', 2: 'Reserva', 3: 'Sem cálculo' }

export const TipoCombustivel = { Gasolina: 1, Etanol: 2, Diesel: 3, Gnv: 4, Eletricidade: 5 } as const
export type TipoCombustivel = (typeof TipoCombustivel)[keyof typeof TipoCombustivel]
export const TIPO_COMBUSTIVEL_LABEL: Record<TipoCombustivel, string> = {
  1: 'Gasolina', 2: 'Etanol', 3: 'Diesel', 4: 'GNV', 5: 'Eletricidade',
}

export const UnidadeEnergia = { L: 1, Kwh: 2, M3: 3 } as const
export type UnidadeEnergia = (typeof UnidadeEnergia)[keyof typeof UnidadeEnergia]
export const UNIDADE_ENERGIA_LABEL: Record<UnidadeEnergia, string> = { 1: 'L', 2: 'kWh', 3: 'm³' }

export const UsoTrecho = { Cidade: 1, Estrada: 2, Misto: 3 } as const
export type UsoTrecho = (typeof UsoTrecho)[keyof typeof UsoTrecho]
export const USO_TRECHO_LABEL: Record<UsoTrecho, string> = { 1: 'Cidade', 2: 'Estrada', 3: 'Misto' }

export const LocalRecarga = { Casa: 1, Publica: 2, NaoAplica: 3 } as const
export type LocalRecarga = (typeof LocalRecarga)[keyof typeof LocalRecarga]
export const LOCAL_RECARGA_LABEL: Record<LocalRecarga, string> = { 1: 'Em casa', 2: 'Pública', 3: 'Não se aplica' }

export const TipoDespesaVeiculo = {
  Ipva: 1, Licenciamento: 2, Seguro: 3, Multa: 4, Estacionamento: 5, Pedagio: 6, Lavagem: 7, Financiamento: 8, Outros: 9,
} as const
export type TipoDespesaVeiculo = (typeof TipoDespesaVeiculo)[keyof typeof TipoDespesaVeiculo]
export const TIPO_DESPESA_VEICULO_LABEL: Record<TipoDespesaVeiculo, string> = {
  1: 'IPVA', 2: 'Licenciamento', 3: 'Seguro', 4: 'Multa', 5: 'Estacionamento', 6: 'Pedágio', 7: 'Lavagem', 8: 'Financiamento', 9: 'Outros',
}

export const OrigemLeitura = { Manual: 1, Abastecimento: 2, Manutencao: 3 } as const
export type OrigemLeitura = (typeof OrigemLeitura)[keyof typeof OrigemLeitura]

/** De onde nasceu o lançamento ligado a um veículo. */
export const OrigemVeiculo = { Abastecimento: 1, Manutencao: 2, Despesa: 3 } as const
export type OrigemVeiculo = (typeof OrigemVeiculo)[keyof typeof OrigemVeiculo]

/** Motivo pelo qual um km informado pede confirmação. */
export const AlertaOdometro = { Regressao: 1, Salto: 2 } as const
export type AlertaOdometro = (typeof AlertaOdometro)[keyof typeof AlertaOdometro]

/** Tipo do trecho de consumo: tanque cheio → cheio ou reserva → reserva. Trecho sem tipo = sem cálculo. */
export const TipoTrecho = { CheioCheio: 1, ReservaReserva: 2 } as const
export type TipoTrecho = (typeof TipoTrecho)[keyof typeof TipoTrecho]
export const TIPO_TRECHO_LABEL: Record<TipoTrecho, string> = { 1: 'Cheio → cheio', 2: 'Reserva → reserva' }

export const TendenciaConsumo = { Insuficiente: 0, Melhorando: 1, Estavel: 2, Piorando: 3 } as const
export type TendenciaConsumo = (typeof TendenciaConsumo)[keyof typeof TendenciaConsumo]
export const TENDENCIA_CONSUMO_LABEL: Record<TendenciaConsumo, string> = {
  0: 'Poucos dados', 1: 'Melhorando', 2: 'Estável', 3: 'Piorando',
}

// ── Veículos: manutenção, vencimentos, insights e FIPE ───────────────────────
/** Situação de um item de manutenção (ou de um vencimento) em relação ao aviso e ao prazo. */
export const StatusManutencao = { Ok: 1, Perto: 2, Vencido: 3 } as const
export type StatusManutencao = (typeof StatusManutencao)[keyof typeof StatusManutencao]
export const STATUS_MANUTENCAO_LABEL: Record<StatusManutencao, string> = { 1: 'Em dia', 2: 'Perto de vencer', 3: 'Vencido' }

/** Qual prazo do item vence primeiro. */
export const MotivoVencimento = { Km: 1, Data: 2 } as const
export type MotivoVencimento = (typeof MotivoVencimento)[keyof typeof MotivoVencimento]

export const OrigemVencimento = { Manutencao: 1, Despesa: 2 } as const
export type OrigemVencimento = (typeof OrigemVencimento)[keyof typeof OrigemVencimento]

/** Tipos da composição do custo: combustível, manutenção e as despesas do veículo. */
export const TipoCustoVeiculo = {
  Combustivel: 1, Manutencao: 2, Ipva: 3, Licenciamento: 4, Seguro: 5, Multa: 6, Estacionamento: 7, Pedagio: 8, Lavagem: 9,
  Financiamento: 10, Outros: 11,
} as const
export type TipoCustoVeiculo = (typeof TipoCustoVeiculo)[keyof typeof TipoCustoVeiculo]
export const TIPO_CUSTO_VEICULO_LABEL: Record<TipoCustoVeiculo, string> = {
  1: 'Combustível', 2: 'Manutenção', 3: 'IPVA', 4: 'Licenciamento', 5: 'Seguro', 6: 'Multa', 7: 'Estacionamento', 8: 'Pedágio',
  9: 'Lavagem', 10: 'Financiamento', 11: 'Outros',
}

export const TipoAlertaVeiculo = { ConsumoPior: 1, KmRegredindo: 2, AbastecimentoDuplicado: 3, PrecoAltoCombustivel: 4 } as const
export type TipoAlertaVeiculo = (typeof TipoAlertaVeiculo)[keyof typeof TipoAlertaVeiculo]

/** Estado da atualização FIPE no painel do admin. */
export const EstadoFipe = { Ativa: 1, Desligada: 2, SemAtualizacaoMensal: 3 } as const
export type EstadoFipe = (typeof EstadoFipe)[keyof typeof EstadoFipe]
export const ESTADO_FIPE_LABEL: Record<EstadoFipe, string> = { 1: 'Ativa', 2: 'Desligada', 3: 'Sem atualização mensal' }
